import React, { useState } from 'react';
import { LegoBuilder } from './components/LegoBuilder/LegoBuilder';
import { Header } from './components/Header/Header';
import { useI18n } from './i18n/I18nContext';
import './styles.css';

function getInitialNameFromUrl(): string {
  if (typeof window === 'undefined') return '';
  const raw = new URLSearchParams(window.location.search).get('name');
  if (!raw) return '';
  return raw
    .replace(/[^a-zA-Z]/g, '')
    .toUpperCase()
    .slice(0, 32);
}

const App: React.FC = () => {
  const [name, setName] = useState<string>(getInitialNameFromUrl);
  const { t } = useI18n();

  return (
    <div className='app'>
      <Header />
      <main id='main' className='main-content' aria-label={t.mainAriaLabel}>
        <LegoBuilder name={name} onNameChange={setName} />
      </main>
    </div>
  );
};

export default App;
